import {useRequiredConfig} from '@domain/shifthandover'
import {Grid} from '@mui/material'
import {FC} from 'react'

import {EquipmentKpis, ManualKpis} from '../components'

type PerformanceDataViewProps = {
  plantId: string
  // Injected per app (cockpit legacy dashboard URL vs Suite buildFeatureUrl) — principle 5.
  dashboardUrl: string
}

// Plant context (UpmPlantProvider) is provided by each app's entry point — cockpit's
// CockpitPerformancePage (SAP plantId → upmId bridge) and the Suite route
// (usePlantUpmIdFromHierarchyId) — so the leaves below read it via useUpmPlantContext().
export const PerformanceDataView: FC<PerformanceDataViewProps> = ({plantId, dashboardUrl}) => {
  const {cceAvailable, shifts} = useRequiredConfig(plantId)

  return cceAvailable ? (
    <EquipmentKpis shifts={shifts} />
  ) : (
    <Grid container spacing={2} width="100%">
      <Grid item xs={12} md={6}>
        <ManualKpis shifts={shifts} dashboardUrl={dashboardUrl} />
      </Grid>
    </Grid>
  )
}
